import { Banner } from "@hireart/component-library";
import { formatDuration, ShiftShape } from "common/utils/timesheet";
import { OverrideDetail } from "./sub-components/OverrideDetail";
import { getOverrideDetails } from "./utils";

export const ManagerOverrideInfo = ({ shift }) => {
  if (!shift.anyValueOverridden) {
    return null;
  }

  const overrideDetails = getOverrideDetails(shift);

  return (
    <Banner variant="warning">
      <div className="flex flex-col gap-2">
        <div className="body-1 font-semibold">Manager overrides</div>
        {overrideDetails.length > 0 ? (
          <ul className="body-2 list-disc pl-4">
            {overrideDetails.map((detail) => (
              <OverrideDetail
                key={detail.label}
                label={detail.label}
                from={detail.from}
                to={detail.to}
              />
            ))}
          </ul>
        ) : (
          <div className="body-2">
            Your manager has adjusted the net paid hours for this shift from{" "}
            <strong>{formatDuration(shift.hoursWorkedEmployee * 3600)}</strong>{" "}
            to{" "}
            <strong>{formatDuration(shift.hoursWorkedEmployer * 3600)}</strong>.
          </div>
        )}
        {shift.notesEmployer && (
          <div className="body-2 mt-2">
            <div className="mb-1 font-semibold">Reason</div>
            <div>{shift.notesEmployer}</div>
          </div>
        )}
      </div>
    </Banner>
  );
};

ManagerOverrideInfo.propTypes = {
  shift: ShiftShape.isRequired,
};
